<div
  *ngIf="{
    isSignedIn: isSignedIn$ | async,
    user: user$ | async,
    currentLanguage: currentLanguage$ | async,
    languages: languages$ | async
  } as data"
>
  <app-header-public
    *ngIf="!data.isSignedIn"
    [currentLanguage]="data.currentLanguage"
    [languages]="data.languages"
    [providerWebsiteId]="providerWebsiteId"
    [showAppsLauncher]="showAppsLauncher"
    [favoritesIcon]="favoritesIcon"
  >
  </app-header-public>

  <app-header-admin
    *ngIf="data.isSignedIn && data.user?.userType === userType.Internal"
    [currentLanguage]="data.currentLanguage"
    [languages]="data.languages"
    [user]="data.user"
    [isSignedIn]="data.isSignedIn"
    [providerWebsiteId]="providerWebsiteId"
    [showAppsLauncher]="showAppsLauncher"
  ></app-header-admin>

  <app-header-jobseeker
    *ngIf="data.isSignedIn && data.user?.userType == userType.Jobseeker"
    [currentLanguage]="data.currentLanguage"
    [languages]="data.languages"
    [user]="data.user"
    [isSignedIn]="data.isSignedIn"
    [providerWebsiteId]="providerWebsiteId"
    [showAppsLauncher]="showAppsLauncher"
    [favoritesIcon]="favoritesIcon"
  ></app-header-jobseeker>
</div>
